import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay, Pagination } from "swiper/modules";
import emailjs from "@emailjs/browser";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "./HeroSlider.css";

const mobileSlides = [{ id: 1, image: "/mobilebanner1.png" }];
const desktopSlides = [{ id: 4, image: "/banner1920x1080.jpg" }];

const HeroSlider = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 991px)");
    setIsMobile(mediaQuery.matches);

    const handleResize = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener("change", handleResize);

    return () => mediaQuery.removeEventListener("change", handleResize);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_1t8qg5b",     // Service ID
        "template_lswjefe",    // Template ID
        e.target,
        "sl0nDpIl2t_3jJWJ-"    // Public Key
      )
      .then(
        () => {
          alert("Enquiry sent successfully ✅");
          e.target.reset();
        },
        (error) => {
          console.error(error);
          alert("Failed to send enquiry ❌");
        }
      );
  };

  const slides = isMobile ? mobileSlides : desktopSlides;

  return (
    <section id="home" className="hero-slider-section">
      <Swiper
        modules={[EffectFade, Autoplay, Pagination]}
        effect="fade"
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop={slides.length > 1}
        className="hero-swiper"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className="hero-slide-wrapper">
              <img
                src={slide.image}
                alt="Gaubliiss Banner"
                className="hero-main-img"
              />
              <div className="hero-dark-overlay"></div>

              <div className="container hero-content-container">
                <div className="row w-100">
                  <div className="col-lg-4 col-md-6">
                    <div className="glass-form-card">
                      <h2 className="form-title">Fresh A2 Milk</h2>
                      <p className="form-subtitle">
                        Get pure organic milk delivered to your doorstep.
                      </p>

                      <form
                        className="hero-enquiry-form"
                        id="bannerform"
                        onSubmit={handleSubmit}
                      >
                        <div className="mb-3">
                          <input
                            type="text"
                            className="glass-input"
                            name="name"
                            placeholder="Your Name"
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <input
                            type="tel"
                            className="glass-input"
                            name="phone"
                            placeholder="Phone Number"
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <input
                            type="text"
                            className="glass-input"
                            name="message"
                            placeholder="Enter Address"
                            required
                          />
                        </div>

                        <button type="submit" className="glass-submit-btn">
                          Get Started
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default HeroSlider;
